import React, { Component } from 'react';
import Img from 'react-image'
import './css/question.css';
import Sound from 'react-sound';

class Question extends Component {

    render() {
      	const contentType = this.props.questionDto['contentType']
      	const content = this.props.questionDto['content']
        
      	if (contentType === 'picture') {
      		return  (
      			<div className="Question">
              <Img src={content}></Img>
          	</div>
          );
      	} else if (contentType === 'text') {
      		return (
          		<div className="Question">
            		<p className="Question-text">
              			{content}
            		</p>
          		</div>
        	);
      	} else if (contentType === 'audio') {
          return  (
            <div className="Question">
              <Img src={"https://doigrgvizfuvs.cloudfront.net/assets/audio.png"}></Img>
              <Sound
                 url={content}
                 playStatus={Sound.status.PLAYING}
                 // onLoading={this.handleSongLoading}
                 // onPlaying={this.handleSongPlaying}
                 // onFinishedPlaying={this.handleSongFinishedPlaying}
              />
            </div>
          );
        } else if (contentType === 'questionEnd') {
      		return null;
      	}
        return null;
    }
}

export default Question;



// WEBPACK FOOTER //
// ./src/components/question.js